import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    gaId: String,
    denyTtl: { type: Number, default: 86400000 },
    debug: { type: Boolean, default: false }
  }

  connect() {
    const consent = this.readConsent()
    if (consent === "granted") { this.enableAnalytics() }
    else if (!consent) { this.show() }
  }

  accept() {
    this.writeConsent("granted")
    this.hide()
    this.enableAnalytics()
  }

  reject() {
    this.writeConsent("denied")
    this.hide()
  }

  enableAnalytics() {
    if (!this.gaIdValue || window._gaLoaded) return
    window._gaLoaded = true

    window.dataLayer = window.dataLayer || []
    window.gtag = function () { window.dataLayer.push(arguments) }

    // Queue config before loading the script so gtag.js picks it up on init
    window.gtag("js", new Date())
    window.gtag("config", this.gaIdValue, {
      anonymize_ip: true,
      debug_mode: this.debugValue
    })

    const s = document.createElement("script")
    s.async = true
    s.src = "https://www.googletagmanager.com/gtag/js"
    s.onload = () => {
      // Track subsequent Turbo navigations
      document.addEventListener("turbo:load", () => {
        window.gtag("event", "page_view", {
          page_path: window.location.pathname,
          page_location: window.location.href
        })
      })
    }
    document.head.appendChild(s)
  }

  readConsent() {
    return document.cookie.match(/(?:^|;\s*)cookie_consent=(granted|denied)/)?.[1] || null
  }

  writeConsent(value) {
    const maxAge = value === "denied" ? Math.round(this.denyTtlValue / 1000) : 15552000
    document.cookie = `cookie_consent=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax`
  }

  show() { this.element.classList.remove("hidden") }
  hide() { this.element.classList.add("hidden") }
}
